import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../utils/api';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';

export const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getModems: build.query({
      query: (args) => {
        if (args) {
          const { page, perPage, searchParams = '', assetId } = args;
          return `${apiUrl.modem}?perPage=${perPage || DEFAULT_PER_PAGE}&page=${page || DEFAULT_PAGE}&${searchParams}${
            assetId ? `&assetId=${assetId}` : ''
          }`;
        }
        return `${apiUrl.modem}`;
      },
      transformResponse: (response) => {
        const pagination = response?.pagination;
        const loadModems = response?.data?.modems;
        return { modems: loadModems, pagination };
      },
      providesTags: ['Modems'],
    }),
    getModemDetailsById: build.query({
      query: ({ id, version }) => `${apiUrl.modem}/${id}${version ? `?version=${version}` : ''}`,
      transformResponse: (response) => {
        const modem = response?.data;
        // Normalize ID field: API returns 'id' but code expects 'modemId'
        const modemId = modem?.id || modem?.modemId;
        return {
          ...response,
          data: {
            ...modem,
            modemId,
            inEffectFrom: modem?.inEffectFrom || null,
            inEffectTo: modem?.inEffectTo || null,
          },
        };
      },
      providesTags: ['Modem'],
    }),
    updateModemById: build.mutation({
      query: ({ id, ...rest }) => ({
        url: `${apiUrl.modem}/${id}`,
        method: 'PUT',
        body: rest,
      }),
      invalidatesTags: ['Modem', 'Modems', 'ModemMachine', 'Machine'],
    }),
    addModem: build.mutation({
      query: (data) => ({
        url: `${apiUrl.modem}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Modems'],
    }),
    deleteModemById: build.mutation({
      query: (id) => ({
        url: `${apiUrl.modem}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Modem', 'Modems', 'ModemMachine'],
    }),
    getModemHistoryById: build.query({
      query: ({ modemId, page }) => `${apiUrl.modem}/${apiUrl.modemHistory}/${modemId}?page=${page}`,
      transformResponse: (response) => {
        const loadModemHistory = response?.data || [];
        const totalCount = response?.pagination?.total || 0; // Fallback if no pagination
        return { modemHistory: loadModemHistory, totalCount };
      },
    }),
    removeModemFromMachine: build.mutation({
      query: ({ id, rest }) => ({
        url: `${apiUrl.modem}/${apiUrl.removeModemFromMachine}/${id}`,
        method: 'PUT',
        body: rest,
      }),
    }),
    deleteModemHistory: build.mutation({
      query: ({ id, version }) => ({
        url: `${apiUrl.modem}/${apiUrl.modemHistory}/${id}${version ? `?version=${version}` : ''}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ModemHistory'],
    }),
    getModemResyncStatus: build.query({
      query: (id) => `${apiUrl.modem}/${id}/resync-status`,
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetModemsQuery,
  useGetModemDetailsByIdQuery,
  useUpdateModemByIdMutation,
  useAddModemMutation,
  useDeleteModemByIdMutation,
  useGetModemHistoryByIdQuery,
  useRemoveModemFromMachineMutation,
  useDeleteModemHistoryMutation,
  useLazyGetModemResyncStatusQuery,
} = extendedApi;
